<template>
  <div :class="sticky ? 'sticky top-0' : 'h-full'">
    <RouterLink
      v-for="(item, i) in items"
      :to="item.to"
      @click.native="$emit('click')"
      :key="`item-${i}`"
      class="sub-nav-link"
      :class="[linkClass, { 'hidden-link': item.hidden }]"
    >
      <span v-if="showActiveIndicator" class="sub-nav-indicator"></span>

      <span class="sub-nav-text">
        <FontAwesomeIcon v-if="item.icon" :icon="item.icon" fixed-width class="sub-nav-icon" />

        <img v-if="item.image" v-lazy="item.image" class="w-6 opacity-75 sub-nav-icon" />

        <span>
          <h3 :class="item.subText ? 'font-medium' : 'font-normal'">{{ item.text }}</h3>

          <p v-if="item.subText" class="font-normal text-gray-darker">{{ item.subText }}</p>
        </span>
      </span>

      <UtilBadgeCount
        v-if="item.badge"
        :count="item.badge < 10 ? item.badge : '9+'"
        unread
        class="sub-nav-badge"
      />

      <FontAwesomeIcon v-else-if="$breakpoint.smAndDown" :icon="faChevronRight" class="sub-nav-badge text-gray" />
    </RouterLink>

    <slot name="footer" />
  </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'LayoutPanelSubNav',
  props: {
    items: {
      type: Array,
      required: true
    },
    showActiveIndicator: {
      type: Boolean,
      default: true
    },
    linkClass: {
      type: String,
      default: 'px-5 xl:px-10 py-3'
    },
    sticky: Boolean
  },
  data() {
    return {
      faChevronRight
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-nav {
  @apply mr-3;
  width: 280px;
}

.sub-nav-link {
  @apply block relative border-b border-gray-lighter;
  max-width: 380px;
  width: 100%;

  &:hover {
    color: #000;
  }

  &.router-link-active {
    background: #f9f9f9;
    @apply text-primary-darker font-semibold;

    .sub-nav-indicator {
      @apply visible;
    }
  }

  &.hidden-link {
    display: none;
  }
}

.sub-nav-indicator {
  width: 0.25rem;
  @apply absolute invisible h-full left-0 top-0 bg-gray;
}

.sub-nav-text {
  @apply flex items-center pr-4;
}

.sub-nav-badge {
  @apply absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.sub-nav-icon {
  @apply mr-4 text-primary-lighter;
  font-size: 1.3em;
}
</style>
